"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.useShare = useShare;
const vue_demi_1 = require("vue-demi");
const poster_1 = require("../poster");
const api_1 = require("./api");
const { useUser } = require('@fegobull/webapi').use;
const { uid, isLogin } = useUser();
/**
 * 创建邀请链接二维码
 *
 * @param {string} url 邀请链接
 * @return {*}  {Promise<string>} 返回二维码的Data URL
 */
async function getQrcode(url) {
    const Qr = await Promise.resolve().then(() => __importStar(require("qrcode")));
    const data = await Qr.toDataURL(url, {
        margin: 0,
        color: {
            light: '#0000',
            dark: '#000'
        }
    });
    return data;
}
/**
 * 使用分享
 * @param shareConfig 分享配置
 * @returns {
 *  state: {
 *    shareUrl: string;
 *    userInfo: Awaited<ReturnType<typeof getUserInfo>>;
 *  }
 * }
 */
function useShare(shareConfig, poster) {
    const state = (0, vue_demi_1.reactive)({
        shareUrl: '',
        userInfo: null,
        qrCode: '',
        poster: ''
    });
    (0, vue_demi_1.onMounted)(async () => {
        if (!isLogin) {
            return;
        }
        const [shareUrl, userInfo] = await Promise.all([(0, api_1.getShareData)(shareConfig), (0, api_1.getUserInfo)()]);
        if (shareUrl) {
            state.qrCode = await getQrcode(shareUrl);
        }
        state.shareUrl = shareUrl;
        state.userInfo = userInfo;
        if (shareUrl
            &&
                state.qrCode
            && userInfo
            && userInfo.nickname
            && userInfo.avatar
            && poster) {
            state.poster = await (0, poster_1.createPoster)({
                qrCode: state.qrCode,
                nick: userInfo.nickname,
                avatar: userInfo.avatar,
                poster,
                uid: userInfo.uid
            });
        }
    });
    return {
        state
    };
}
//# sourceMappingURL=data:application/json;base64,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